const URGENCY_THRESHOLD_HOURS = 2; // Threshold in hours for displaying urgency callout
const ERRORS = {
	DELIVERY_DATE: 'Failed to retrieve delivery date information for the specified postal code.',
	POSTAL_CODE_UPDATE: 'Failed to update postal code. Please try again.',
	POSTAL_CODE_NOT_FOUND: 'Postal code not found for your location. Please enter it manually.',
	GEOLOCATION_ERROR: 'Unable to retrieve your location. Please enter a postal code manually.',
	GEOLOCATION_NOT_SUPPORTED: 'Geolocation is not supported by your browser. Please enter a postal code manually.'
};
const FALLBACK_CALLOUT_TEXT = {
	ARRIVES: 'Arrives',
	ARRIVES_IN: 'Arrives in',
	SHIPS_IN: 'Ships in',
	GET_IT_BY: 'Get it by'
};
const FALLBACK_VARIATIONS = {
	USE_ARRIVES_FALLBACK: 'UseArrivesFallback',
	USE_SHIPS_FALLBACK: 'UseShipsFallback'
};

export {
	URGENCY_THRESHOLD_HOURS,
	FALLBACK_CALLOUT_TEXT,
	FALLBACK_VARIATIONS,
	ERRORS
};
